import './NotFound.css';

export default function NotFound() {

    return (
        <div>
            <h1>404 Page</h1>

            <div>Page not found message</div>
        </div>
        
    );
}
